<template>
  <article class="participant">
    <v-avatar>
      <v-badge
        :value="!participant.confirmed"
        bottom
        color="#ff6f00"
        offset-x="20"
        offset-y="17"
      >
        <span slot="badge">?</span>
        <v-avatar
          class="mr-2"
          left
          size="32"
        >
          <v-img :src="getAvatar(participant.avatar, 100)" />
        </v-avatar>
      </v-badge>
    </v-avatar>
    <div class="name">
      {{ participant.dancerName }}
    </div>
    <div class="action">
      <div
        v-if="participant.checkedIn"
        class="checkin-label"
      >
        <v-icon class="check-icon">
          {{ mdiCheck }}
        </v-icon>
        Checked-in
      </div>

      <template v-if="canEdit && !participant.checkedIn">
        <v-btn
          :loading="loading"
          class="ml-auto white--text font-weight-bold"
          color="var(--color-green)"
          height="32"
          tile
          @click="checkInParticipant"
        >
          Check-In
        </v-btn>
      </template>
    </div>
    <div
      v-if="'studios' in participant && !!participant.studios?.length"
      class="wrap-studio"
    >
      <router-link
        v-for="studio in participant.studios"
        :key="studio.id"
        :to="{ name: 'Studio', params: { id: String(studio.id) } }"
        class="studio-link"
      >
        <v-avatar
          size="24"
          class="studio-image"
        >
          <img
            :alt="studio.name"
            :src="getStudioImage(studio.image, 48)"
          />
        </v-avatar>
        <span class="studio-name">{{ studio.name }}</span>
      </router-link>
    </div>
  </article>
</template>

<script>
import Images from '@/mixins/image'
import { mdiCheck } from '@mdi/js'
import { eventApi } from '@/enitites/event'

export default {
  name: 'BattleCrewDetailsParticipant',
  mixins: [Images],
  props: {
    participant: {
      type: Object,
      required: true,
    },
    eventId: {
      type: Number,
      required: true,
    },
    canEdit: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      mdiCheck,
      loading: false,
    }
  },
  methods: {
    async checkInParticipant() {
      this.loading = true

      const updatedEvent = await eventApi.checkInUser(this.eventId, this.participant.id)
      if (updatedEvent) this.$emit('update:event', updatedEvent)

      this.$emit('reload:battle')

      this.loading = false
    },
    getStudioImage(id, size) {
      if (!id) return '/img/default-studio-image.webp'
      return `${process.env.VUE_APP_IMG_URL}/${id}/${size}/${size}`
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/style/mixins';

.participant {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  border-bottom: 1px solid var(--color-grey-600);

  .name {
    margin-left: 6px;
  }

  .action {
    margin-left: auto;
  }

  .checkin-label {
    color: var(--color-green);
  }

  .check-icon {
    margin-right: 9px;
    color: var(--color-green) !important;
  }

  .wrap-studio {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    margin-top: 10px;
    width: 100%;

    .studio-link {
      display: flex;
      gap: 4px;
      align-items: center;
      color: var(--color-grey-300) !important;
      font-size: 14px;
    }

    .studio-image {
      flex: 0 0 24px;
      width: 24px;
      height: 24px;
      border: 1px solid var(--color-grey-500);
      border-radius: 999px;
      overflow: hidden;
    }
  }
}
</style>
